export default __webpack_public_path__ + "static/man-with-time-0c4886e5b9bea48c115cfea74bac15eb.png";